import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as actionTypes from "../../../constants/ActionTypes/Web/Customer/SignUp";
import { _CALLGETAPI } from '../../../api/apiHandler';
import { LOCALSESSIONDATAKEYS, SUCCESS, WEB_CUSTOMER_API_ENDPOINT } from '../../../constants/AppConstants';
import { getLocalSessionData, setLocalSessionData } from '../../../utils/Authentication/handleUserSession';
import i18next from 'i18next';
import { _USERROLESSERVICE } from '../../../store/UserRoles/UserRolesSaga';
import { userRoles } from '../../../constants/UserRoles';
import { UserEnrolledDevicesServiceInit } from '../../../store/UserEnrolledDevices/UserEnrolledDevicesSlice';

function _GETUSERBOCACCOUNTDETAILS() {
    const endpoint = WEB_CUSTOMER_API_ENDPOINT.GET_USER_BOC_ID_BY_ADB2CID;
    const payload = {
        params: {
            adb2cId: getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID)
        }
    }
    return _CALLGETAPI(endpoint, payload)
        .then(response => {
            return response;
        })
        .catch((error) => {
            throw error;
        });
}

/**
 * This method calls the API to fetch the user user roles
 * 
 * Logic
 *  - The user can have any role; Customer, Admin, CSAgentAdmin, CSAgentViewer etc
 *  - On response, if the user has "Customer" role then GetUserEnrolledDevices API will be invoked
 *  - On response, if the role array is empty (for new users) then also GetUserEnrolledDevices API will be invoked
 *  - (GetUserEnrolledDevices API will be invoked to check the maximum enrolled device limit of a customer) 
 *  - Since this saga is only used by websignup flow, always dispatch GetUserBOCIdByADB2CID success action
 * 
 * @param {string} userId 
 * @param {object} payload [BOCResp]
 * 
 * @returns void
 */
function* getUserRoleAndEnrolledDevices(userId, payload) {
    try {
        const adb2cId = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
        const userRolesInfo = yield call(_USERROLESSERVICE, userId, adb2cId);
        if (userRolesInfo.actionStatus.toUpperCase() === SUCCESS) {
            if (userRolesInfo.roles.length === 0 || userRolesInfo.roles.includes(userRoles.CUSTOMER)) {
                yield put(UserEnrolledDevicesServiceInit({
                    doEnrolmentCheck: true
                }));
            }

            /** dispatch GetUserBOCIdByADB2CID Success action */
            yield put({ type: actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_SUCCESS, userData: payload });

        } else {
            i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")
            yield put({
                type: actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_ERROR,
                message: i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")
            });
        }

    } catch (e) {
        yield put({ type: actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_ERROR, message: e.message });
    }
}

function* getUserBOCAccountDetails() {
    try {
        const BOCResp = yield call(_GETUSERBOCACCOUNTDETAILS);
        const BOC_UID = BOCResp.userId;
        setLocalSessionData(LOCALSESSIONDATAKEYS.UID, BOC_UID);
        (BOC_UID)
            ? yield* getUserRoleAndEnrolledDevices(BOC_UID, BOCResp)
            : yield put({ type: actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_SUCCESS, userData: BOCResp });
    } catch (e) {
        /**
         * This conditional statement is added to avoid
         * displaying error message in view while logout from app
         */
        if (e instanceof TypeError === false && e.message !== "401") {
            yield put({ type: actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_ERROR, message: e.message });
        }
    }
}

function* getUserBOCAccountDetailsStandalone() {
    try {
        const BOCResp = yield call(_GETUSERBOCACCOUNTDETAILS);
        const BOC_UID = BOCResp.userId;
        if(BOC_UID){
            setLocalSessionData(LOCALSESSIONDATAKEYS.UID, BOC_UID);
            yield put({ type: actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_SUCCESS, userData: BOCResp })
        } else {
            yield put({ type: actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_SUCCESS, userData: {BOC_NO_UserID_Err: true }})
        }
    } catch (e) {
        /**
         * This conditional statement is added to avoid
         * displaying error message in view while logout from app
         */
        if (e instanceof TypeError === false && e.message !== "401") {
            yield put({ type: actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_ERROR, message: e.message });
        }
    }
}

function* GetUserBOCIdByADB2CId() {
    yield takeEvery(actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_INIT, getUserBOCAccountDetails);
    yield takeLatest(actionTypes.GET_USER_BOC_ID_BY_ADB2C_ID_STANDALONE, getUserBOCAccountDetailsStandalone);
}

export default GetUserBOCIdByADB2CId;
export { _GETUSERBOCACCOUNTDETAILS };